<div class="d-flex flex-column">
	<div style="max-width: 1300px">
		<div
			class="d-flex my-3 flex-row justify-content-end align-items-end gap-2 position-relative">
			<label
				class="text-tertiary text-center fw-semibold position-absolute top-50 start-50 translate-middle">
				{{ tituloTabela }}
			</label>
			<seira-select-list-menu
				[opcoes]="opcoesColunas"
				[opcoesSelecionadas]="colunasSelecionadas"
				[disabled]="disabledSelectList || carregando"
				[tituloBotao]="'Personalizar colunas'"
				(atualizarOpcoesSelecionadas)="
					setColunasSelecionadas($event)
				"></seira-select-list-menu>
		</div>

		<div
			*ngIf="carregando; else tabela"
			class="d-flex justify-content-center align-items-center w-100 h-50"
			style="min-height: 500px">
			<seira-loading [pageCentered]="false"></seira-loading>
		</div>

		<ng-template #tabela>
			<seira-public-table
				#tabelaNDC
				id="tabela-ndc"
				[loading]="carregando"
				[searching]="false"
				[info]="false"
				[hasHeader]="false"
				[scrollX]="true"
				[data]="resultados"
				[columns]="colunasNDC">
			</seira-public-table>
		</ng-template>

		<seira-card-info [texto]="descricaoRelatorio" />
	</div>
</div>
